import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, Link } from 'react-router-dom'
import ContainerContent from '../../components/ContainerContent';
import styled from 'styled-components';
import './styles/ThemeInfo.css';
import { BackBtn } from '../../components/shared/NavigationButtons';
import { getUrl } from '../../components/getSubjectId';

const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
`;

const Row = styled.div`
  display: flex;
  gap: 30px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Cell = styled.div`
  flex: 1;
  
  p {
    padding: 0;
  }
  
  ul {
    padding-left: 20px;
  }
  
  li {
    margin-bottom: 8px;
    line-height: 1.5;
  }
`;


// Функция для разделения текста по двоеточию
const splitTextByColon = (text: string) => {
  if (!text) return { label: '', content: '' };
  const parts = text.split(':');
  if (parts.length < 2) return { label: '', content: text };
  return { label: parts[0] + ':', content: parts.slice(1).join(':').trim() };
};

const SubjectNameGender = () => {
  const { t } = useTranslation()
  return <span className={'linkSpan afade'} data-fade>{t('goBack')}</span>
}

const Step2Page: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [searchParams] = useSearchParams()

  const themeId = searchParams.get('theme')
  const gender = searchParams.get('gender')
  const race = searchParams.get('race')
  const age = searchParams.get('age')

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 700px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    document.body.classList.add('max-width-1200');
    return () => {
      document.body.classList.remove('max-width-1200');
    };
  }, []);

  // Получаем данные из перевода и парсим JSON с обработкой ошибок
  let columnsData: { options: any[] } = { options: [] };
  try {
    const columnsDataString = t('themeInfo.step2.page.columns');
    if (typeof columnsDataString === 'string' && columnsDataString.startsWith('{')) {
      columnsData = JSON.parse(columnsDataString);
    }
  } catch (e) {
    console.error('Error parsing columns data:', e);
  }

  return (
    <ContainerContent>
      <div className={'paddDesc'}>
        <div className={'wrapTitleNav'}>
          <Link to={getUrl('theme-info')} className={'mytitle'} style={{ width: 'auto' }}>
            <BackBtn></BackBtn>
            {!isMobile && <SubjectNameGender />}
          </Link>
        </div>

        <div className="theme-header" style={{ marginBottom: '100px' }}>
          <h1 className="theme-title">{t('themeInfo.step2.page.title')}</h1>
        </div>

        <div className="theme-description" style={{ marginBottom: '25%' }}>
          <RowsContainer>
            <Row>
              {columnsData.options.map((option: any, index: number) => {
                const { label, content } = splitTextByColon(option.title);
                return (
                  <Cell key={index}>
                    <p><strong>{label}</strong> {content}</p>
                  </Cell>
                );
              })}
            </Row>

            <Row>
              {columnsData.options.map((option: any, index: number) => {
                const { label, content } = splitTextByColon(option.bestFor);
                return (
                  <Cell key={index}>
                    <p><strong>{label}</strong> {content}</p>
                  </Cell>
                );
              })}
            </Row>

            <Row style={{ marginBottom: '100px' }}>
              {columnsData.options.map((option: any, index: number) => {
                const { label, content } = splitTextByColon(option.benefit);
                return (
                  <Cell key={index}>
                    <p><strong>{label}</strong> {content}</p>
                  </Cell>
                );
              })}
            </Row>

            <Row>
              {columnsData.options.map((option: any, index: number) => (
                <Cell key={index}>
                  <Link
                    to={`${option.buttonLink}?theme=${themeId}&gender=${gender || ''}&race=${race || ''}&age=${age || ''}`}
                    className={'btn btn2'}
                    style={{ marginTop: '20px', display: 'inline-block' }}
                    draggable="false"
                  >
                    {option.buttonText}
                  </Link>
                </Cell>
              ))}
            </Row>
          </RowsContainer>

        </div>
      </div>
    </ContainerContent>
  );
};

export default Step2Page;
